import React from "react";
import { CreateNFeContext } from "../../../../../../Context";
import { increaseMonths } from "../../../../../../../../../../utils";

export function usePaymentScheduler() {
  const context = React.useContext(CreateNFeContext);

  const setInvoices = (startDate, installments, paymentMethod) => {
    startDate = startDate || new Date();

    const dates = increaseMonths(new Date(startDate), installments);

    let { total_nfe, total_paid } = context.nfe;
    const { discount_value } = context.nfe.identification;
    total_nfe = parseFloat(total_nfe) - parseFloat(discount_value || 0);
    const { payments } = context.nfe;
    const { setNFePayments } = context.handlers;
    const installmentValue = ((total_nfe - total_paid) / installments).toFixed(
      2
    );
    let invoices = [];
    total_nfe = total_nfe - total_paid;
    let diff = total_nfe - parseFloat(installmentValue) * installments;
    diff = diff.toFixed(2);

    for(let date of  dates) {
      invoices.push({
        payment_method: paymentMethod.payment_method,
        name: paymentMethod.name,
        due_date: date,
        value: parseFloat(installmentValue),
      });
    }
    invoices[invoices.length - 1].value += parseFloat(diff);

    setNFePayments([...payments, ...invoices]);
  };

  return setInvoices;
}

export function useInstallmentsValue() {
  const adaptInstallmentValue = (nfe, installments) => {
    let { total_nfe, total_paid } = nfe;
    const { discount_value } = nfe.identification;
    total_nfe = parseFloat(total_nfe) - parseFloat(discount_value || 0);
    return ((total_nfe - total_paid) / installments).toFixed(2);
  };
  return adaptInstallmentValue;
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/AddPayment/Invoices/hooks/index.js